import { Check, CircleAlert, FileClock } from 'lucide-react';
import { Button } from './Button';
import type { DraftSnapshot } from './localDraft';
export function DraftStatus({
  snapshot,
  onRetry,
  timeZone = 'Europe/Moscow',
}: {
  snapshot: Pick<DraftSnapshot<unknown>, 'status' | 'savedAt' | 'error'>;
  onRetry: () => void;
  timeZone?: string;
}) {
  const failed = snapshot.status === 'error';
  const time = draftTime(snapshot.savedAt, timeZone);
  return (
    <div
      data-slot="draft-status"
      className="flex flex-wrap items-center gap-3 rounded-md border border-line bg-muted p-3"
    >
      <span className={failed ? 'text-danger-strong' : 'text-fg-muted'} aria-hidden>
        {failed ? (
          <CircleAlert className="size-4" />
        ) : snapshot.status === 'initial' ? (
          <FileClock className="size-4" />
        ) : (
          <Check className="size-4" />
        )}
      </span>
      <div className="min-w-0 flex-1" role="status" aria-live="polite">
        <p className={failed ? 'text-xs font-medium text-danger-strong' : 'text-xs font-medium text-fg'}>
          {failed
            ? 'Черновик не сохранён'
            : snapshot.status === 'restored'
              ? 'Черновик восстановлен'
              : snapshot.status === 'saved'
                ? 'Черновик сохранён'
                : 'Черновик появится после первой правки'}
        </p>
        <p className="mt-0.5 text-2xs text-fg-muted">
          {failed
            ? 'Изменения пока только в открытой форме. ' + (snapshot.error ?? 'Повтори сохранение.')
            : 'На этом устройстве' + (time ? ' · ' + time : '')}
        </p>
      </div>
      {failed && (
        <Button type="button" variant="secondary" size="sm" onClick={onRetry}>
          Повторить
        </Button>
      )}
    </div>
  );
}

function draftTime(at: number | null, timeZone: string): string | null {
  if (at === null) return null;
  try {
    return new Intl.DateTimeFormat('ru-RU', {
      timeZone,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'short',
    }).format(at);
  } catch {
    return 'Время недоступно';
  }
}
